import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { NavigateService } from '../services/navigate/navigate.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard {
  constructor(
    private auth: AuthService,
    private navigateService: NavigateService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.auth.isAuthenticated() && !state.url.includes('auth/set-password')) {
      // User is logged in and not trying to access the reset password page
      this.navigateService.toApp()
      return false;
    } else {
      return true;
    }
  }
}
